var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import muiTypography from '@customink/design-tokens/build/ci_light/js/typography.mui';
var themeOptions = function (theme) { return ({
    components: {
        MuiDialog: {
            defaultProps: {
                maxWidth: 'md',
            },
            styleOverrides: {
                root: {
                    '.MuiPaper-root': {
                        background: designTokens.color.shade.white.value,
                        boxShadow: "".concat(theme.spacing(0, 0.5, 1), " rgba(0, 0, 0,0.08)"),
                        borderRadius: theme.spacing(0.5),
                    },
                    '.MuiBackdrop-root': {
                        backgroundColor: designTokens.color.gray.obsidian,
                    },
                    '.MuiDialog-paperFullScreen': {
                        borderRadius: 0,
                    },
                },
            },
        },
        MuiDialogTitle: {
            defaultProps: {},
            styleOverrides: {
                root: __assign(__assign({ overflowWrap: 'anywhere', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: theme.spacing(3), paddingTop: theme.spacing(3) }, muiTypography.heading4), { color: designTokens.color.shade.black.value, 
                    // to maintain position of XCloseIcon when {children} wrap to multiple lines
                    '.MuiIconButton-root': {
                        alignSelf: 'flex-start',
                    } }),
            },
        },
        MuiDialogContent: {
            defaultProps: {},
            styleOverrides: {
                root: {
                    paddingBottom: '0',
                },
            },
        },
        MuiDialogContentText: {
            defaultProps: {},
            styleOverrides: {
                root: __assign(__assign({}, muiTypography.paragraphSmall), { color: designTokens.color.shade.black.value, paddingBottom: theme.spacing(0.5) }),
            },
        },
        MuiDialogActions: {
            defaultProps: {},
            styleOverrides: {
                root: {
                    padding: theme.spacing(3),
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=dialogTheme.js.map